export const DISPLAY_ORDER_LIST_MENU_ITEMS = ['Recommend', 'ApprovalRequested'];

export const DISPLAY_ORDER_LIST_ACTION_TYPES = ['none', 'recommend', 'approvalRequested'] as const;

export const UPDATE_TO_APPROVED_MENU_ITEMS = ['UpdateToApproved', 'DeleteApprovalRequest'] as const;
